import './index.scss'
import Swiper from 'swiper/swiper-bundle.min.js'
import '../../assets/scripts/jquery.nicescroll.min'

// 自定义滚动条插件
if (window.devicePixelRatio < 2) {
    if (!(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent))) {
        $('body').niceScroll({
            mousescrollstep: 40,
            scrollspeed: 80,
            zindex: 101,
            cursorcolor: '#BDBDBD',
            cursorborder: '1px solid #BDBDBD',
            cursorwidth: '5px',
            cursoropacitymax: 0.6,
            smoothscroll: true,
            iframeautoresizeL: true,
        });
    }
}
function resizeNiceScroll(){
    if (window.devicePixelRatio < 2) {
        if (!(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent))) {
            setTimeout(() => {
            $('body').getNiceScroll().resize()
            }, 500);
        }
    }
}



var tableswiper = new Swiper(".pro-size .size-table .mySwiper", {
    allowTouchMove: false,
    autoHeight: true, //高度随内容变化
    effect: 'fade',
    fadeEffect: {
        crossFade: true,
    }
});

var tabindex = 0

!(function(){
    tabF()
})()
$(window).resize(function(){
    tabF()
})

$('.pro-size .size-tabs .tab-cont span').on('click',function(){
    tabindex = $(this).index()
    tabF()
    tableswiper.slideTo(tabindex)
    resizeNiceScroll()
})

// 产品tab效果,计算背景色块的宽度和位置
function tabF(){
    $('.pro-size .size-tabs .tab-cont span').eq(tabindex).addClass('active').siblings().removeClass('active')
    let $bgEl = $('.pro-size .size-tabs .tab-cont .bg')
    let activetabEl = $('.pro-size .size-tabs .tab-cont span').eq(tabindex)

    $bgEl.css({
        width: activetabEl[0].clientWidth + 'px',
        left: activetabEl[0].offsetLeft + 'px'
    })
}

// 表单点击提示文字上移
$('.pro-feedback .form input,.pro-feedback .form textarea').focus(function () {
    if (!$(this).parents('.form-item').hasClass('active')) {
        $(this).parents('.form-item').addClass('active')
    }
}).blur(function () {
    if ($(this).val() == '') {
        $(this).parents('.form-item').removeClass('active')
    }
})